import { TimelineMax, TweenMax } from 'gsap';
import { useMemo } from 'react';
import styled from './index.module.scss';
import { EFVideoPlay } from '@/components/UI/svg/stories';
import { useGlobal } from '@/utils/useGlobal';
import Image from '@/components/UI/Image';

const StoryNewLight = ({ handleShowVideo }: { handleShowVideo: (url: string) => void }) => {
    const { useEffect, isMobile, useLang } = useGlobal();
    const { t } = useLang('brandstory');
    let controller = null;
    useEffect(() => {
        controller = new ScrollMagic.Controller();

        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.storyNewlight', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0.5, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 800, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineA1 = new TimelineMax();

        const tweenA1 = TweenMax.to(`.storyNewlight .header`, 0.3, { opacity: 1 });
        const tweenA2 = TweenMax.to(`.storyNewlight .videobox`, 0.25, { opacity: 1 });
        const tweenA3 = TweenMax.to(`.storyNewlight .left`, 0.25, { y: 0 });
        const tweenA4 = TweenMax.to(`.storyNewlight .first`, 0.25, { y: 0 });
        const tweenA5 = TweenMax.to(`.storyNewlight .next`, 0.25, { y: 0 });

        timelineA1.add(tweenA1, 0).add(tweenA2, 0.2).add(tweenA3, 0.2).add(tweenA4, 0.2).add(tweenA5, 0.25);
        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);
    }, []);

    const videoHtml = useMemo(() => {
        if (isMobile) {
            return (
                <div className="videobox">
                    <div className="text">
                        <p>{t('newlight.paraga')}</p>
                        <p>{t('newlight.paragb')}</p>
                    </div>
                    <div className="img" onClick={() => handleShowVideo('https://www.youtube.com/embed/hMAQanW-aDI')}>
                        <Image
                            src="/img/stories/h5/newlight/light.jpg"
                            layout="fill"
                            className="fullImgs"
                            alt={t('menu.newlight')}
                            aria-label={t('menu.newlight')}
                        />
                        <EFVideoPlay className="videoplay" />
                    </div>
                </div>
            );
        }
        return (
            <div className="videobox">
                <div className="left" onClick={() => handleShowVideo('https://www.youtube.com/embed/hMAQanW-aDI')}>
                    <Image
                        src="/img/stories/pc/newlight/light.jpg"
                        layout="fill"
                        className="fullImgs"
                        alt={t('menu.newlight')}
                        aria-label={t('menu.newlight')}
                    />
                    <EFVideoPlay className="videoplay" />
                </div>
                <div className="right">
                    <p className="first">{t('newlight.paraga')}</p>
                    <p className="next">{t('newlight.paragb')}</p>
                </div>
            </div>
        );
    }, [isMobile]);

    return (
        <div id="storyNewlight" className={`${isMobile ? styled.mobile_newlight : styled.newlight} storyNewlight ${isMobile ? '' : 'content'}`}>
            <div className="header">
                <h5 className="screen-title">{t('menu.newlight')}</h5>
                <h5 className="screen-desc">{t('newlight.title')}</h5>
            </div>
            {videoHtml}
        </div>
    );
};

export default StoryNewLight;
